(function(){
  const CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'TRY';
  const fmt = (cents)=> new Intl.NumberFormat(undefined,{style:'currency',currency:CURRENCY}).format((cents||0)/100);
  const isTR = ()=> document.documentElement.lang === 'tr';
  const $ = (s,r=document)=> r.querySelector(s);

  /* ---------- cart drawer ---------- */
  const scrim=$('#cartd-scrim'), drawer=$('#cartd'), items=$('#cartd-items'), foot=$('#cartd-foot'), subEl=$('#cartd-sub');
  function openDrawer(){ if(!drawer) return; scrim.classList.add('open'); drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
  function closeDrawer(){ if(!drawer) return; scrim.classList.remove('open'); drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
  document.addEventListener('click',e=>{ if(e.target.closest('[data-close]')) closeDrawer(); });
  document.addEventListener('keydown',e=>{ if(e.key==='Escape') closeDrawer(); });

  function updateCount(n){ document.querySelectorAll('.nav-cart .count').forEach(b=>{ b.textContent=n; b.hidden = !n; }); }

  function renderCart(cart){
    updateCount(cart.item_count);
    if(!items) return;
    if(cart.item_count===0){
      items.innerHTML = '<div class="cartd-empty">'+(isTR()?'Sepetiniz boş.':'Your cart is empty.')+'<br><a href="'+(isTR()?'/tr':'')+'/collections/training">'+(isTR()?'Antrenman ürünlerine göz atın →':'Browse training →')+'</a></div>';
      foot.hidden = true; return;
    }
    foot.hidden = false;
    subEl.textContent = fmt(cart.items_subtotal_price);
    items.innerHTML = cart.items.map(it=>{
      const img = it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/i,'_160x$1$2')}" alt="">` : '<img alt="">';
      const variant = (it.variant_title && it.variant_title!=='Default Title') ? `<div class="vr">${it.variant_title}</div>` : '';
      return `<div class="cartd-line" data-key="${it.key}">
        ${img}
        <div><div class="nm">${it.product_title}</div>${variant}<div class="pr">${fmt(it.final_line_price)}</div>
          <div class="cartd-qty"><button data-dec aria-label="Decrease">−</button><span>${it.quantity}</span><button data-inc aria-label="Increase">+</button></div>
        </div>
        <button class="cartd-rm" data-rm>${isTR()?'Kaldır':'Remove'}</button>
      </div>`;
    }).join('');
  }

  async function getCart(){ const r=await fetch('/cart.js',{headers:{'Accept':'application/json'}}); return r.json(); }
  async function changeLine(key,qty){
    const r=await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})});
    return r.json();
  }

  if(items){
    items.addEventListener('click',async e=>{
      const line=e.target.closest('.cartd-line'); if(!line) return;
      const key=line.dataset.key;
      const cur=parseInt(line.querySelector('.cartd-qty span').textContent,10);
      if(e.target.closest('[data-inc]')) renderCart(await changeLine(key,cur+1));
      else if(e.target.closest('[data-dec]')) renderCart(await changeLine(key,Math.max(0,cur-1)));
      else if(e.target.closest('[data-rm]')) renderCart(await changeLine(key,0));
    });
  }

  // nav cart icon opens drawer (and refreshes)
  document.addEventListener('click',async e=>{
    if(e.target.closest('#nav-cart')){ e.preventDefault(); renderCart(await getCart()); openDrawer(); }
  });

  /* ---------- PDP variant selection + add to cart ---------- */
  const form=$('#pdp-form');
  if(form){
    const dataEl=$('#pdp-variant-data');
    const variants= dataEl ? JSON.parse(dataEl.textContent) : [];
    const idInput=$('#pdp-variant-id'), priceNow=$('#pdp-price-now'), addBtn=$('#pdp-add'), addLabel=$('#pdp-add-label'), msg=$('#pdp-msg');
    const selected=[];
    document.querySelectorAll('.pdp-opt').forEach(opt=>{
      const i=parseInt(opt.dataset.optionIndex,10);
      const on=opt.querySelector('.pdp-swatch.is-on')||opt.querySelector('.pdp-swatch');
      selected[i]= on ? on.dataset.value : null;
    });
    function findVariant(){ return variants.find(v=> selected.every((val,i)=> v.options[i]===val)); }
    function refresh(){
      const v=findVariant();
      document.querySelectorAll('.pdp-opt').forEach(opt=>{
        opt.querySelectorAll('.pdp-swatch').forEach(b=>{
          const pressed=b.dataset.value===selected[parseInt(b.dataset.optionIndex,10)];
          b.setAttribute('aria-pressed',pressed?'true':'false');
        });
      });
      if(v){
        idInput.value=v.id;
        priceNow.textContent=fmt(v.price);
        const ok=v.available;
        addBtn.disabled=!ok;
        addLabel.textContent= ok ? (isTR()?'Sepete ekle':'Add to cart') : (isTR()?'Tükendi':'Sold out');
      } else { addBtn.disabled=true; addLabel.textContent= isTR()?'Mevcut değil':'Unavailable'; }
    }
    document.querySelectorAll('.pdp-swatch').forEach(b=>{
      b.addEventListener('click',()=>{ selected[parseInt(b.dataset.optionIndex,10)]=b.dataset.value; refresh(); });
    });
    const qty=$('#pdp-qty');
    $('#pdp-minus').addEventListener('click',()=>{ qty.value=Math.max(1,parseInt(qty.value||'1',10)-1); });
    $('#pdp-plus').addEventListener('click',()=>{ qty.value=parseInt(qty.value||'1',10)+1; });
    refresh();

    form.addEventListener('submit',async e=>{
      e.preventDefault();
      msg.textContent=''; msg.classList.remove('err');
      try{
        const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:parseInt(idInput.value,10),quantity:parseInt(qty.value||'1',10)})});
        if(!r.ok){ const er=await r.json(); throw new Error(er.description||'Error'); }
        renderCart(await getCart()); openDrawer();
      }catch(err){ msg.textContent= isTR()? 'Eklenemedi. Tekrar deneyin.' : 'Could not add. Please try again.'; msg.classList.add('err'); }
    });
  }

  /* ---------- PDP gallery thumbs ---------- */
  document.querySelectorAll('.pdp-thumb').forEach(t=>{
    t.addEventListener('click',()=>{
      const main=$('#pdp-main-img'); if(main && t.dataset.full) main.src=t.dataset.full;
      document.querySelectorAll('.pdp-thumb').forEach(x=>x.classList.remove('on')); t.classList.add('on');
    });
  });

  // initialize nav count on load
  getCart().then(renderCart).catch(()=>{});
})();
